import { createSlice } from "@reduxjs/toolkit";
import { sleep } from "../../common/utils/utils";
import { getAPI } from "../../api/nodeRedApi/axiosApi";
import { addSnackAsync } from "../../app/coreSlice";

import {
  getSchedules as getSchedulesDUMMY,
  addSchedule as addScheduleDUMMY,
  updateSchedule as updateScheduleDUMMY,
  removeSchedule as removeScheduleDUMMY,
  activateSchedule as activateScheduleDUMMY,
} from "../../api/fakeApi/schedules";
import {
  getSchedules as getSchedulesAPI,
  addSchedule as addScheduleAPI,
  updateSchedule as updateScheduleAPI,
  removeSchedule as removeScheduleAPI,
  activateSchedule as activateScheduleAPI,
  getSchedulesInstances as getSchedulesInstancesAPI,
  addScheduleInstance as addScheduleInstanceAPI,
  stopScheduleInstance as stopScheduleInstanceAPI,
  deleteScheduleInstance as deleteScheduleInstanceAPI,
} from "../../api/nodeRedApi/schedules";
import moment from "moment";

export const schedulesSlice = createSlice({
  name: "schedules",
  initialState: {
    loader: null,
    error: null,
    schedules: null,
    schedulesInstances: null,
  },
  reducers: {
    setLoader: (state, action) => {
      state.loader = action.payload;
    },

    setError: (state, action) => {
      state.error = action.payload;
    },

    setSchedules: (state, action) => {
      state.schedules = action.payload;
    },

    setSchedulesInstances: (state, action) => {
      state.schedulesInstances = action.payload;
    },
  },
});

export const { setLoader, setError, setSchedules, setSchedulesInstances } = schedulesSlice.actions;

export const getSchedules = (project) => async (dispatch) => {
  console.log("GET");
  dispatch(setLoader("LOADING"));
  let schedules = [];
  let api = getAPI(project?.id);
  if (api) {
    schedules = await getSchedulesAPI(api);
  } else {
    schedules = getSchedulesDUMMY();
    await sleep(1000);
  }
  schedules.map((zone) => (zone.schedules = zone.schedules.sort((a, b) => (a.designation > b.designation && 1) || -1)));

  dispatch(setSchedules(schedules));
  dispatch(setLoader(null));
};

export const addSchedule =
  (project, { sensorId, designation, startTime, duration, weekdays }) =>
  async (dispatch) => {
    dispatch(setLoader("ADD_SCHEDULE"));
    let startTimeStr = moment(startTime).format('HH:mm');
    console.log('startTime: %o', startTime);
    let api = getAPI(project?.id);
    if (api) {
      await addScheduleAPI(api, sensorId, designation, startTimeStr, duration, weekdays, true);
    } else {
      addScheduleDUMMY(sensorId, designation, startTimeStr, duration, weekdays, true);
      await sleep(1000);
    }
    dispatch(addSnackAsync("success", "SCHEDULE_ADDED"));
    dispatch(setLoader(null));
    dispatch(getSchedules(project));
  };

export const updateSchedule =
  (project, { id, sensorId, designation, startTime, duration, weekdays, active }) =>
  async (dispatch) => {
    console.log("UPDATE");
    dispatch(setLoader("UPDATE_SCHEDULE"));
    let startTimeStr = moment(startTime).format('HH:mm');
    let api = getAPI(project?.id);
    if (api) {
      await updateScheduleAPI(api, id, sensorId, designation, startTimeStr, duration, weekdays, active);
    } else {
      updateScheduleDUMMY(id, sensorId, designation, startTimeStr, duration, weekdays, active);
      await sleep(1000);
    }
    dispatch(addSnackAsync("success", "SCHEDULE_UPDATED"));
    dispatch(setLoader(null));
    dispatch(getSchedules(project));
  };

export const activateSchedule = (project, id, active) => async (dispatch) => {
  console.log("UPDATE");
  dispatch(setLoader("UPDATE_SCHEDULE"));
  let api = getAPI(project?.id);
  if (api) {
    await activateScheduleAPI(api, id, active);
  } else {
    activateScheduleDUMMY(id, active);
    await sleep(1000);
  }
  dispatch(addSnackAsync("success", "SCHEDULE_UPDATED"));
  dispatch(setLoader(null));
  dispatch(getSchedules(project));
};

export const removeSchedule = (project, id) => async (dispatch) => {
  console.log("REMOVE id: %o", id);
  dispatch(setLoader("REMOVE_SCHEDULE"));
  let api = getAPI(project?.id);
  if (api) {
    await removeScheduleAPI(api, id);
  } else {
    removeScheduleDUMMY(id);
    await sleep(1000);
  }
  dispatch(addSnackAsync("success", "SCHEDULE_REMOVED"));
  dispatch(setLoader(null));
  dispatch(getSchedules(project));
};

export const getSchedulesInstances = (project) => async (dispatch) => {
  //console.log("GET");
  //dispatch(setLoader("LOADING"));
  let schedulesInstances = [];
  let api = getAPI(project?.id);
  if (api) {
    schedulesInstances = await getSchedulesInstancesAPI(api);
  } else {
    await sleep(1000);
  }

  dispatch(setSchedulesInstances(schedulesInstances));
  //dispatch(setLoader(null));
};

export const addScheduleInstance =
  (project, { sensorId, startDate, duration }) =>
  async (dispatch) => {
    dispatch(setLoader("LOADING"));
    let api = getAPI(project?.id);
    if (api) {
      await addScheduleInstanceAPI(api, sensorId, startDate, duration);
    } else {
      await sleep(1000);
    }
    dispatch(addSnackAsync("success", "INSTANCE_CREATED"));
    dispatch(setLoader(null));
  };

export const stopScheduleInstance = (project, id) => async (dispatch) => {
  dispatch(setLoader("LOADING"));
  let api = getAPI(project?.id);
  if (api) {
    await stopScheduleInstanceAPI(api, id);
  } else {
    await sleep(1000);
  }
  dispatch(addSnackAsync("success", "INSTANCE_STOPED"));
  dispatch(setLoader(null));
};

export const deleteScheduleInstance = (project, id) => async (dispatch) => {
  dispatch(setLoader("LOADING"));
  let api = getAPI(project?.id);
  if (api) {
    await deleteScheduleInstanceAPI(api, id);
  } else {
    await sleep(1000);
  }
  dispatch(addSnackAsync("success", "INSTANCE_STOPED"));
  dispatch(setLoader(null));
}; 

export const selectLoader = (state) => state.schedules.loader;
export const selectError = (state) => state.schedules.error;
export const selectSchedules = (state) => state.schedules.schedules;
export const selectSchedulesInstances = (state) => state.schedules.schedulesInstances;
export const selectSelectedProject = (state) => state.authentication.selectedProject;

export default schedulesSlice.reducer;
